<script lang="ts">
    export let text: string;
    export let href: string = "#";
    export let target: string = "_self";
</script>

<a {href} {target}>
    <p class="hover:text-accent transition-colors duration-200 ease-in-out">{@html text}</p>
</a>
